import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./About.css";

gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(imageRef.current, {
        x: -80,
        opacity: 0,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      });

      gsap.from(textRef.current, {
        x: 80,
        opacity: 0,
        duration: 1.2,
        ease: "power3.out",
        delay: 0.2,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section id="About" className="story-section" ref={sectionRef}>
      <div className="story-container">
      

        {/* Content */}
        <div className="story-content" ref={textRef}>
          <h2>About Us</h2>
          <p>
            We're Acence — a Complete Branding Agency powered by design + Al.
We build brands that move markets, spark emotion, and grow communities. From strategy to visuals - logo design, packaging, social media, and websites - we craft every detail with precision and purpose.
          </p>
          <p>
            Founded with a vision to redefine technology, Acence
            continues to push the boundaries of what’s possible on the road.
          </p>
        </div>

      </div>
    </section>
  );
};

export default About;
